import React, { useState } from "react"
import { Table } from "antd"

// Config
// import { APP_CONFIG } from "../../../../config"

// Constants
import { TEMPLATE } from "../../../../constants"
import ModalReceipt from "./ModalReceipt"
// import { COL_REFUEL_EVENTS, COL_THEFT_EVENTS } from "../../../../constants/template/report/columns"


const {
    COL_REFUEL_EVENTS, 
    COL_THEFT_EVENTS
} = TEMPLATE.REPORT.COLUMN

// const {
//     AWS_URI,
//     AWS_SDK_CONFIG
// } = APP_CONFIG

const FARefuelTheftTable = ({
    mode,
    report,
    // summary,
    plate,
    fuelUnitPrice
}) => {

    /**
     * Process data
     */
    const vehicleKeys = Object.keys(report)

    let refuelArray = []
    let theftArray = []

    vehicleKeys.forEach(vk => {
        const { refuels, thefts } = report[vk] || {}
        
        refuelArray = [ ...refuelArray, ...refuels ]
        theftArray = [ ...theftArray, ...thefts ]
    })

    const formattedData = (data) => {

        const fuel = data.difference
        const cost = fuel * fuelUnitPrice
        const startTime = data.startLog?.vehicleTime
        const vid = data.startLog?.vid || data.endLog?.vid || '-'

        return {
            key: data.startLog?.vehicleTime,
            startTime: startTime,
            endTime: data.endLog?.vehicleTime, 
            fuel: fuel,
            cost: cost,
            location: data.endLog?.location,
            reviewedBy: '-',
            reviewTime: data.endLog?.vehicleTime,
            plate: plate,
            vid: vid,
            // attachment: `https://${AWS_URI.s3.asset.bucket}.s3.${AWS_SDK_CONFIG.credential.region}.amazonaws.com/${startTime}/${AWS_URI.s3.asset.key.fuelReceipt}/${startTime}_${data.vid}.png`
        }
    }

    const receiptHDLR = (data) => {
        setData(data)
        setIsOpen(true)
    }

    const dataSource = {
        ['refuel']: refuelArray.map(r => formattedData(r)),
        ['theft']: theftArray.map(r => formattedData(r))
    }
 
    const columns = {
        ['refuel']: COL_REFUEL_EVENTS({ reportState: false,  receiptHDLR }),
        ['theft']: COL_THEFT_EVENTS({ reportState: false , receiptHDLR })
    }

    // Modal state
    const [ isOpen, setIsOpen ] = useState(false)
    const [ data, setData ] = useState(null)

    const cancelReceiptActionHDLR = () => {
        setIsOpen(false)
        setData(null)
    }

    const saveReceiptActionHDLR = (data) => {
        console.log(data)
    }

    return (
        <div>
            {
                isOpen
                &&
                <ModalReceipt open={isOpen} onCancel={cancelReceiptActionHDLR} onSave={saveReceiptActionHDLR} receiptData={data} />
            }
            <Table 
                columns={columns[mode]}
                dataSource={dataSource[mode]}
                scroll={{
                    // y: '50vh',
                    x: columns[mode] && columns[mode].length * 200
                }}
            />
        </div>
    )
}

export default React.memo(FARefuelTheftTable)